var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNiftyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 132,
    viewBox: "0 0 391 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.288 41.395c11.875 29.749.68 63.73-26.554 80.593-27.233 16.864-62.643 11.742-83.981-12.147l-2.022 2.022a10.363 10.363 0 0 1-13.73.779c.308-.243.601-.503.88-.779l28.54-28.5.628-.627a9.898 9.898 0 0 1 13.436 0l.546.556 12.937 12.935c.074.068.153.13.227.198a10.434 10.434 0 0 0 14.346-.303zM31.605 9.683c24.766-15.13 56.509-12.314 78.223 6.942l.9-.9a10.363 10.363 0 0 1 13.82-.708c-.356.277-.694.578-1.01.9L71.974 67.479a9.898 9.898 0 0 1-13.548 0L45.415 54.467c-.121-.131-.212-.283-.333-.404-4.07-4.014-10.61-4.014-14.68 0-.132.121-.213.273-.334.404L2.083 82.453c-7.224-28.11 4.757-57.639 29.522-72.77z",
    id: "a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.831%",
    y1: "19.837%",
    x2: "83.831%",
    y2: "80.351%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EE3D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#019B8E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#019B8E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3A3A3A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.48 92.69a2 2 0 0 1-1.42.63h-11.81a1.81 1.81 0 0 1-1.37-.63 2 2 0 0 1-.59-1.41V58.84a26.57 26.57 0 0 0-.29-4.29 6.59 6.59 0 0 0-1.07-2.82 4.15 4.15 0 0 0-2.2-1.51 12.64 12.64 0 0 0-3.66-.44 12 12 0 0 0-4.39.88 43.59 43.59 0 0 0-4.78 2.24v38.38a2 2 0 0 1-.59 1.41c-.343.4-.843.63-1.37.63h-11.82a2.18 2.18 0 0 1-2.05-2.05v-52a2 2 0 0 1 2-2H183a1.87 1.87 0 0 1 1.37.59 1.9 1.9 0 0 1 .59 1.38v2.37a27.49 27.49 0 0 1 7.62-4 27.79 27.79 0 0 1 8.3-1.13 18.63 18.63 0 0 1 8.64 1.76 13.55 13.55 0 0 1 5.27 4.74 19.29 19.29 0 0 1 2.64 7c.5 2.852.745 5.744.73 8.64v32.66a2 2 0 0 1-.68 1.41zM246.43 29.07a2 2 0 0 1-2 2h-12.64a2 2 0 0 1-2-2V20a2 2 0 0 1 2-2h12.69a2 2 0 0 1 2 2l-.05 9.07zm-.43 62.3a2 2 0 0 1-2 2h-11.82a2 2 0 0 1-2-2v-52a2 2 0 0 1 2-2h11.91a2 2 0 0 1 2 2l-.09 52zM288.62 29.46h-4.79c-1.5 0-2.41.28-2.73.84a9.17 9.17 0 0 0-.49 3.81v3.26h8A1.87 1.87 0 0 1 290 38a1.9 1.9 0 0 1 .59 1.38v8a1.9 1.9 0 0 1-.59 1.32 1.87 1.87 0 0 1-1.37.59h-8v42.09a1.87 1.87 0 0 1-.58 1.36 1.85 1.85 0 0 1-1.36.58h-11.96a1.85 1.85 0 0 1-1.36-.59 1.88 1.88 0 0 1-.58-1.37V49.19L257 47.92a3.45 3.45 0 0 1-1.42-.73 1.66 1.66 0 0 1-.63-1.32v-6.45a2.18 2.18 0 0 1 2.05-2.05h7.81v-3.12a27.83 27.83 0 0 1 1.07-8.45 10.39 10.39 0 0 1 8.2-7.57 32.59 32.59 0 0 1 7-.68 33.27 33.27 0 0 1 3.81.19c1.107.127 2.41.32 3.91.58 1.233.193 1.853.84 1.86 1.94v7.56c.007 1.1-.673 1.647-2.04 1.64zM329.83 93.43c-1.5.26-2.803.453-3.91.58a33.51 33.51 0 0 1-3.81.19 34.92 34.92 0 0 1-7-.63 10.58 10.58 0 0 1-5.11-2.49 11.62 11.62 0 0 1-3.13-5.08 27.81 27.81 0 0 1-1.07-8.45V49.19l-7.8-1.27a3.45 3.45 0 0 1-1.42-.73 1.66 1.66 0 0 1-.63-1.32v-6.45a2.18 2.18 0 0 1 2.05-2.05h7.81v-8c-.014-.49.2-.96.58-1.27a3.36 3.36 0 0 1 1.36-.68l11.84-2.05h.29c.46-.02.911.138 1.26.44.335.315.514.761.49 1.22v10.34h8A1.87 1.87 0 0 1 331 38a1.9 1.9 0 0 1 .59 1.38v8a1.9 1.9 0 0 1-.59 1.32 1.87 1.87 0 0 1-1.37.59h-8V77.7a8.93 8.93 0 0 0 .49 3.76c.327.553 1.237.83 2.73.83h4.79c1.367 0 2.05.55 2.05 1.65v7.56c-.007 1.093-.627 1.737-1.86 1.93zM390.47 39.13a.39.39 0 0 1 0 .24.38.38 0 0 0 0 .24L374 97.14a43.77 43.77 0 0 1-2.64 7 14.85 14.85 0 0 1-3.81 4.93 16 16 0 0 1-6 3 33.46 33.46 0 0 1-9 1c-.913 0-1.913-.05-3-.15-1.087-.1-2.193-.213-3.32-.34a41.561 41.561 0 0 1-3.12-.49 20.27 20.27 0 0 1-2.34-.59 11.44 11.44 0 0 1-1.42-.63 1.18 1.18 0 0 1-.63-1.12v-7.91a1.71 1.71 0 0 1 .59-1.32 2 2 0 0 1 1.37-.54h.2l2.78.2c1.073.067 2.18.147 3.32.24 1.14.093 2.247.173 3.32.24 1.07.06 2 .1 2.78.1a6.84 6.84 0 0 0 4.1-1.07 7.5 7.5 0 0 0 2.34-4l.88-3h-1.46a13.14 13.14 0 0 1-2.59-.24 5.92 5.92 0 0 1-2.39-1.12 8.59 8.59 0 0 1-2.2-2.69 22.4 22.4 0 0 1-1.9-5L337 39.62c-.07-.22-.103-.45-.1-.68 0-1.04.667-1.56 2-1.56h13a1.5 1.5 0 0 1 1.22.54c.305.388.52.839.63 1.32l8.79 36.72c.26 1.24.65 1.86 1.17 1.86h.88l9.08-38.57c.117-.5.37-.956.73-1.32a1.8 1.8 0 0 1 1.32-.54h13a1.89 1.89 0 0 1 1.32.49c.312.338.468.791.43 1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#00B8A9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 76.61l.55.55c-.187-.193-.37-.377-.55-.55zM31.08 77.2l.62-.62c-.213.193-.42.4-.62.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#01BAAB",
    fillRule: "nonzero",
    opacity: 0.197,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#b)",
    mask: "url(#c)",
    cx: -18.917,
    cy: 65.58,
    rx: 94.586,
    ry: 94.166
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#d)",
    opacity: 0.3,
    mask: "url(#c)",
    cx: 108.038,
    cy: 113.924,
    r: 78.611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.657 162.268c35.058 0 63.478-28.42 63.478-63.478s-28.42-63.478-63.478-63.478-91.25 56.465-91.25 91.522c0 35.058 56.192 35.434 91.25 35.434z",
    fill: "#01BBAC",
    opacity: 0.5,
    mask: "url(#c)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiftyLogo);
export default __webpack_public_path__ + "static/media/nifty-logo.622c3309bcffc8b8f40273706462925f.svg";
export { ForwardRef as ReactComponent };